import { websiteBuilderGenerateDefaultBox } from "../../container/websiteBuilderBox";
import { websiteBuilderGenerateDefaultButton } from "../../element/websiteBuilderButton";
import { WebsiteBuilderDividerWeight, websiteBuilderGenerateDefaultDivider } from "../../element/websiteBuilderDivider";
import { websiteBuilderGenerateDefaultHeading } from "../../element/websiteBuilderHeading";
import { WEBSITE_BUILDER_TEMPLATE_ICON_ASSET_IDENTITIES, websiteBuilderGenerateDefaultIcon, websiteBuilderResolveIconAssetIdentity } from "../../element/websiteBuilderIcon";
import { websiteBuilderGenerateDefaultParagraph } from "../../element/websiteBuilderParagraph";
import { IWebsiteBuilderIconAsset } from "redux/reducers/models/websiteBuilder";
import { IWebsiteBuilderContent, websiteBuilderGenerateDefaultContent } from "../websiteBuilderContent";

export function websiteBuilderMembershipPlansTemplate(
  iconAssets: IWebsiteBuilderIconAsset[],
): IWebsiteBuilderContent {
  const section = websiteBuilderGenerateDefaultContent();
  const subHeading = websiteBuilderGenerateDefaultParagraph();
  const subHeadingDivider = websiteBuilderGenerateDefaultDivider();
  const firstCard = websiteBuilderGenerateDefaultBox();
  const firstIcon = websiteBuilderGenerateDefaultIcon(
    websiteBuilderResolveIconAssetIdentity(iconAssets, WEBSITE_BUILDER_TEMPLATE_ICON_ASSET_IDENTITIES.golf),
  );
  const firstHeading = websiteBuilderGenerateDefaultHeading();
  const firstDescription = websiteBuilderGenerateDefaultParagraph();
  const firstButton = websiteBuilderGenerateDefaultButton();
  const secondCard = websiteBuilderGenerateDefaultBox();
  const secondIcon = websiteBuilderGenerateDefaultIcon(
    websiteBuilderResolveIconAssetIdentity(iconAssets, WEBSITE_BUILDER_TEMPLATE_ICON_ASSET_IDENTITIES.star),
  );
  const secondHeading = websiteBuilderGenerateDefaultHeading();
  const secondDescription = websiteBuilderGenerateDefaultParagraph();
  const secondDetail = websiteBuilderGenerateDefaultParagraph();
  const secondButton = websiteBuilderGenerateDefaultButton();
  const thirdCard = websiteBuilderGenerateDefaultBox();
  const thirdIcon = websiteBuilderGenerateDefaultIcon(
    websiteBuilderResolveIconAssetIdentity(iconAssets, WEBSITE_BUILDER_TEMPLATE_ICON_ASSET_IDENTITIES.listBullets),
  );
  const thirdHeading = websiteBuilderGenerateDefaultHeading();
  const thirdDescription = websiteBuilderGenerateDefaultParagraph();
  const thirdButton = websiteBuilderGenerateDefaultButton();

  section.section.layout.desktop.height = 665;
  section.section.layout.tablet.height = 517;
  section.section.layout.mobile.height = 1235;

  subHeading.element.layout.desktop.position = { x: 80, y: 80 };
  subHeading.element.layout.tablet.position = { x: 32, y: 40 };
  subHeading.element.layout.mobile.position = { x: 25, y: 40 };
  subHeading.element.layout.desktop.dimensions = { width: 160, height: 25 };
  subHeading.element.layout.tablet.dimensions = { width: 160, height: 25 };
  subHeading.element.layout.mobile.dimensions = { width: 160, height: 25 };
  subHeading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "12px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "2026 MEMBERSHIP PLANS", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#285E1A",
          },
        }],
      }],
    }],
  };

  subHeadingDivider.element.layout.desktop.position = { x: 245, y: 89 };
  subHeadingDivider.element.layout.tablet.position = { x: 197, y: 49 };
  subHeadingDivider.element.layout.mobile.position = { x: 190, y: 49 };
  subHeadingDivider.element.layout.desktop.dimensions = { width: 125, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.layout.tablet.dimensions = { width: 100, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.layout.mobile.dimensions = { width: 90, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.settings.weight = WebsiteBuilderDividerWeight.THIN;
  subHeadingDivider.element.settings.color = "#285E1A";

  firstCard.container.layout.desktop.position = { x: 80, y: 115 };
  firstCard.container.layout.tablet.position = { x: 32, y: 75 };
  firstCard.container.layout.mobile.position = { x: 25, y: 75 };
  firstCard.container.layout.desktop.dimensions = { width: 270, height: 470 };
  firstCard.container.layout.tablet.dimensions = { width: 220, height: 400 };
  firstCard.container.layout.mobile.dimensions = { width: 270, height: 360 };
  firstCard.container.settings.backgroundColor = "#F9FAFB";
  firstCard.container.settings.borderRadius = 12;

  firstIcon.element.layout.desktop.position = { x: 24, y: 28 };
  firstIcon.element.layout.tablet.position = { x: 18, y: 23 };
  firstIcon.element.layout.mobile.position = { x: 20, y: 23 };
  firstIcon.element.layout.desktop.dimensions = { width: 30, height: 30 };
  firstIcon.element.layout.tablet.dimensions = { width: 30, height: 30 };
  firstIcon.element.layout.mobile.dimensions = { width: 30, height: 30 };
  firstIcon.element.settings.color = "#285E1A";

  firstHeading.element.layout.desktop.position = { x: 24, y: 90 };
  firstHeading.element.layout.tablet.position = { x: 18, y: 70 };
  firstHeading.element.layout.mobile.position = { x: 20, y: 75 };
  firstHeading.element.layout.desktop.dimensions = { width: 222, height: 75 };
  firstHeading.element.layout.tablet.dimensions = { width: 184, height: 70 };
  firstHeading.element.layout.mobile.dimensions = { width: 230, height: 55 };
  firstHeading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "26px",
        tablet: "22px",
        mobile: "22px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1, lineHeight: "1.15" },
      content: [{
        type: "text",
        text: "Multi-course memberships", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  firstDescription.element.layout.desktop.position = { x: 24, y: 170 };
  firstDescription.element.layout.tablet.position = { x: 18, y: 140 };
  firstDescription.element.layout.mobile.position = { x: 20, y: 140 };
  firstDescription.element.layout.desktop.dimensions = { width: 222, height: 150 };
  firstDescription.element.layout.tablet.dimensions = { width: 184, height: 170 };
  firstDescription.element.layout.mobile.dimensions = { width: 230, height: 135 };
  firstDescription.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "15px",
        tablet: "12px",
        mobile: "14px",
      },
    },
    content: [{
      type: "paragraph",
      attrs: { lineHeight: "1.4" },
      content: [{
        type: "text",
        text: "Experience courses across Canada as an Adult, Intermediate, Teen, or Junior, with more value for your rounds and flexible access-all under one membership.", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  firstButton.element.layout.desktop.position = { x: 24, y: 400 };
  firstButton.element.layout.tablet.position = { x: 18, y: 335 };
  firstButton.element.layout.mobile.position = { x: 20, y: 295 };
  firstButton.element.layout.desktop.dimensions = { width: 222, height: 42 };
  firstButton.element.layout.tablet.dimensions = { width: 184, height: 42 };
  firstButton.element.layout.mobile.dimensions = { width: 230, height: 42 };
  firstButton.element.settings.label = "Purchase now"; // TODO: Translation
  firstButton.element.settings.backgroundColor = "#285E1A";
  firstButton.element.settings.borderColor = "#285E1A";
  firstButton.element.settings.color = "#FFFFFF";
  firstButton.element.settings.borderRadius = 8;

  secondCard.container.layout.desktop.position = { x: 365, y: 115 };
  secondCard.container.layout.tablet.position = { x: 274, y: 75 };
  secondCard.container.layout.mobile.position = { x: 25, y: 455 };
  secondCard.container.layout.desktop.dimensions = { width: 270, height: 470 };
  secondCard.container.layout.tablet.dimensions = { width: 220, height: 400 };
  secondCard.container.layout.mobile.dimensions = { width: 270, height: 360 };
  secondCard.container.settings.backgroundColor = "#F9FAFB";
  secondCard.container.settings.borderRadius = 12;

  secondIcon.element.layout.desktop.position = { x: 24, y: 28 };
  secondIcon.element.layout.tablet.position = { x: 18, y: 23 };
  secondIcon.element.layout.mobile.position = { x: 20, y: 23 };
  secondIcon.element.layout.desktop.dimensions = { width: 30, height: 30 };
  secondIcon.element.layout.tablet.dimensions = { width: 30, height: 30 };
  secondIcon.element.layout.mobile.dimensions = { width: 30, height: 30 };
  secondIcon.element.settings.color = "#285E1A";

  secondHeading.element.layout.desktop.position = { x: 24, y: 90 };
  secondHeading.element.layout.tablet.position = { x: 18, y: 70 };
  secondHeading.element.layout.mobile.position = { x: 20, y: 75 };
  secondHeading.element.layout.desktop.dimensions = { width: 222, height: 40 };
  secondHeading.element.layout.tablet.dimensions = { width: 184, height: 60 };
  secondHeading.element.layout.mobile.dimensions = { width: 230, height: 35 };
  secondHeading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "26px",
        tablet: "22px",
        mobile: "22px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1, lineHeight: "1.15" },
      content: [{
        type: "text",
        text: "Round packages", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  secondDescription.element.layout.desktop.position = { x: 24, y: 170 };
  secondDescription.element.layout.tablet.position = { x: 18, y: 140 };
  secondDescription.element.layout.mobile.position = { x: 20, y: 120 };
  secondDescription.element.layout.desktop.dimensions = { width: 222, height: 65 };
  secondDescription.element.layout.tablet.dimensions = { width: 184, height: 44 };
  secondDescription.element.layout.mobile.dimensions = { width: 230, height: 50 };
  secondDescription.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "15px",
        tablet: "12px",
        mobile: "14px",
      },
    },
    content: [{
      type: "paragraph",
      attrs: { lineHeight: "1.4" },
      content: [{
        type: "text",
        text: "Save with Riverdale Golf Course's Prepaid Round Packages!", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  secondDetail.element.layout.desktop.position = { x: 24, y: 245 };
  secondDetail.element.layout.tablet.position = { x: 18, y: 185 };
  secondDetail.element.layout.mobile.position = { x: 20, y: 170 };
  secondDetail.element.layout.desktop.dimensions = { width: 222, height: 125 };
  secondDetail.element.layout.tablet.dimensions = { width: 184, height: 110 };
  secondDetail.element.layout.mobile.dimensions = { width: 230, height: 115 };
  secondDetail.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "15px",
        tablet: "12px",
        mobile: "14px",
      },
    },
    content: [{
      type: "paragraph",
      attrs: { lineHeight: "1.4" },
      content: [{
        type: "text",
        text: "Buy multiple rounds in advance, valid for a year, and fully transferable. Purchase today and tee off anytime!", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  secondButton.element.layout.desktop.position = { x: 24, y: 400 };
  secondButton.element.layout.tablet.position = { x: 18, y: 335 };
  secondButton.element.layout.mobile.position = { x: 20, y: 295 };
  secondButton.element.layout.desktop.dimensions = { width: 222, height: 42 };
  secondButton.element.layout.tablet.dimensions = { width: 184, height: 42 };
  secondButton.element.layout.mobile.dimensions = { width: 230, height: 42 };
  secondButton.element.settings.label = "Choose a package"; // TODO: Translation
  secondButton.element.settings.backgroundColor = "#285E1A";
  secondButton.element.settings.borderColor = "#285E1A";
  secondButton.element.settings.color = "#FFFFFF";
  secondButton.element.settings.borderRadius = 8;

  thirdCard.container.layout.desktop.position = { x: 650, y: 115 };
  thirdCard.container.layout.tablet.position = { x: 516, y: 75 };
  thirdCard.container.layout.mobile.position = { x: 25, y: 835 };
  thirdCard.container.layout.desktop.dimensions = { width: 270, height: 470 };
  thirdCard.container.layout.tablet.dimensions = { width: 220, height: 400 };
  thirdCard.container.layout.mobile.dimensions = { width: 270, height: 360 };
  thirdCard.container.settings.backgroundColor = "#F9FAFB";
  thirdCard.container.settings.borderRadius = 12;

  thirdIcon.element.layout.desktop.position = { x: 24, y: 28 };
  thirdIcon.element.layout.tablet.position = { x: 18, y: 23 };
  thirdIcon.element.layout.mobile.position = { x: 20, y: 23 };
  thirdIcon.element.layout.desktop.dimensions = { width: 30, height: 30 };
  thirdIcon.element.layout.tablet.dimensions = { width: 30, height: 30 };
  thirdIcon.element.layout.mobile.dimensions = { width: 30, height: 30 };
  thirdIcon.element.settings.color = "#285E1A";

  thirdHeading.element.layout.desktop.position = { x: 24, y: 90 };
  thirdHeading.element.layout.tablet.position = { x: 18, y: 70 };
  thirdHeading.element.layout.mobile.position = { x: 20, y: 75 };
  thirdHeading.element.layout.desktop.dimensions = { width: 222, height: 75 };
  thirdHeading.element.layout.tablet.dimensions = { width: 184, height: 70 };
  thirdHeading.element.layout.mobile.dimensions = { width: 230, height: 55 };
  thirdHeading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "26px",
        tablet: "22px",
        mobile: "22px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1, lineHeight: "1.15" },
      content: [{
        type: "text",
        text: "Course-specific memberships", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  thirdDescription.element.layout.desktop.position = { x: 24, y: 170 };
  thirdDescription.element.layout.tablet.position = { x: 18, y: 140 };
  thirdDescription.element.layout.mobile.position = { x: 20, y: 140 };
  thirdDescription.element.layout.desktop.dimensions = { width: 222, height: 125 };
  thirdDescription.element.layout.tablet.dimensions = { width: 184, height: 130 };
  thirdDescription.element.layout.mobile.dimensions = { width: 230, height: 105 };
  thirdDescription.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "15px",
        tablet: "12px",
        mobile: "14px",
      },
    },
    content: [{
      type: "paragraph",
      attrs: { lineHeight: "1.4" },
      content: [{
        type: "text",
        text: "Designed for the golfers who love the familiarity of the fairways, the faces, and the friendly atmosphere.", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  thirdButton.element.layout.desktop.position = { x: 24, y: 400 };
  thirdButton.element.layout.tablet.position = { x: 18, y: 335 };
  thirdButton.element.layout.mobile.position = { x: 20, y: 295 };
  thirdButton.element.layout.desktop.dimensions = { width: 222, height: 42 };
  thirdButton.element.layout.tablet.dimensions = { width: 184, height: 42 };
  thirdButton.element.layout.mobile.dimensions = { width: 230, height: 42 };
  thirdButton.element.settings.label = "Purchase now"; // TODO: Translation
  thirdButton.element.settings.backgroundColor = "#285E1A";
  thirdButton.element.settings.borderColor = "#285E1A";
  thirdButton.element.settings.color = "#FFFFFF";
  thirdButton.element.settings.borderRadius = 8;

  firstCard.children = [firstIcon, firstHeading, firstDescription, firstButton];
  secondCard.children = [secondIcon, secondHeading, secondDescription, secondDetail, secondButton];
  thirdCard.children = [thirdIcon, thirdHeading, thirdDescription, thirdButton];

  section.children = [subHeading, subHeadingDivider, firstCard, secondCard, thirdCard];

  return section;
}
